import { SmsSender1 } from "CommonData";
import httpRequest from "utils/httpRequest";
const URL = "/api";

export const checkSameTelNo = async (bsd_id, data) => {
  const requestBody = {
    bsd_id: bsd_id,
    sms_telno: data.sms_telno,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/checkSameTelNo`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const send_authcode = async (data, authCode) => {
  const requestBody = {
    sms_sender: SmsSender1,
    sms_telno: data.sms_telno,
    sms_content: authCode,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/send_authcode`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getSmsReceiveList = async (bsd_id, e_line, cur_page) => {
  const requestBody = {
    bsd_id,
    e_line,
    cur_page,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/smsRecvList`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getFnMobileNbr = async (user_id) => {
  const requestBody = {
    user_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/getFnMobileNbr`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getSmsReceive = async (bsd_id, user_id) => {
  const requestBody = {
    bsd_id,
    user_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/getSmsRecv`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const insertSmsReceive = async (data, bsd_id) => {
  const requestBody = {
    bsd_id,
    user_id: data.user_id,
    user_name: data.user_name,
    sms_telno: data.sms_telno,
    sms_yn: 'Y',
  };

  try {
    const response = await httpRequest(
      "post",
      `${URL}/insSMSRecv`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateSmsReceive = async (bsdState, org_user_name, org_sms_telno, org_sms_yn, data) => {
  const requestBody = {
    bsd_id: bsdState,
    user_name: org_user_name,
    sms_telno: org_sms_telno,
    sms_yn: org_sms_yn,
    up_user_name: data.user_name,
    up_sms_telno: data.sms_telno,
    up_sms_yn: data.sms_yn
  };

  try {
    const response = await httpRequest(
      "post",
      `${URL}/updSMSRecv`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deleteSmsReceive = async (bsd_id, sms_telno) => {
  const requestBody = {
    bsd_id,
    sms_telno,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/delSMSRecv`,
      requestBody
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

// export const getStatusList = async (bsd_id) => {
//   const requestBody = {
//     bsd_id,
//   };
//   try {
//     const response = await httpRequest(
//       "post",
//       `${URL}/delSMSRecv`,
//       requestBody
//     );
//     return response;
//   } catch (error) {
//     console.log(error);
//   }
// };

// export const getPopFieldUser = async (fn_group_id) => {
//   const requestBody = {
//     fn_group_id,
//   };
//   try {
//     const response = await httpRequest("post", `${URL}/popUsr3`, requestBody);
//     return response;
//   } catch (error) {
//     console.log(error);
//   }
// };

